import type {
  ResolutionColumns,
  ResolutionListFilters,
  ResolutionSort,
  ResolutionStatus
} from '@library/types/resolutions/resolutionsList';
import type { SelectOptions, TableColumn } from '@library/types/utils';

export const defaultResolutionListFilters: ResolutionListFilters = {
  adminUsers: [],
  completedOnFromDate: undefined,
  completedOnToDate: undefined,
  createdAtFromDate: undefined,
  createdAtToDate: undefined,
  resolutionStatuses: []
};

export const resolutionStatusOptions: SelectOptions<ResolutionStatus> = [
  { key: 'completed', name: 'Completed', value: 'completed' },
  { key: 'discarded', name: 'Discarded', value: 'discarded' },
  { key: 'draft', name: 'Draft', value: 'draft' },
  { key: 'incomplete', name: 'Incomplete', value: 'incomplete' },
  {
    key: 'manually_completed',
    name: 'Manually Completed',
    value: 'manually_completed'
  },
  { key: 'preprocessing', name: 'Preprocessing', value: 'preprocessing' },
  { key: 'processing', name: 'Processing', value: 'processing' },
  { key: 'ready', name: 'Ready', value: 'ready' },
  {
    key: 'unrecoverable_error',
    name: 'Unrecoverable Error',
    value: 'unrecoverable_error'
  },
  {
    key: 'unrecoverable_preprocessing_error',
    name: 'Unrecoverable Preprocessing Error',
    value: 'unrecoverable_preprocessing_error'
  }
];

export const RESOLUTIONS_TABLE_HEADER: Array<TableColumn<ResolutionColumns>> = [
  {
    column: 'id',
    essential: true,
    label: 'ID',
    sortEnabled: true,
    width: 'w-[5%] px-3'
  },
  {
    column: 'type',
    essential: true,
    label: 'Type',
    sortEnabled: false,
    width: 'w-[5%] px-3'
  },
  {
    column: 'admin',
    essential: true,
    label: 'Admin',
    sortEnabled: false,
    width: 'w-1/5 px-3'
  },
  {
    column: 'reason',
    essential: true,
    label: 'Reason',
    sortEnabled: false,
    width: 'flex-1 px-3'
  },
  {
    column: 'created_at',
    essential: true,
    label: 'Created At',
    sortEnabled: true,
    width: 'w-[15%] px-3'
  },
  {
    column: 'completed_on',
    essential: true,
    label: 'Completed On',
    sortEnabled: false,
    width: 'w-[15%] px-3'
  },
  {
    column: 'status',
    essential: true,
    label: 'Status',
    sortEnabled: false,
    width: 'w-[15%] px-3'
  }
];
export const DEFAULT_RESOLUTION_SORT: ResolutionSort = {
  sortBy: 'created_at',
  sortDirection: 'desc'
};
